import { mainData } from "./model/data";
import { listMarkup, listPageMarkup } from "./view/listMarkup";

import { generateMarkup } from "./view/generateMarkup";

import { materialFilter, categoryFilter } from "./model/filters";

import { initComponent } from "./components/initComponent";

initComponent();

const mainContainer = document.querySelector(".list__content");
const productRange = document.querySelector('meta[name="range"]').content;
const productType = document.querySelector('meta[name="type"]').content;

mainContainer.insertAdjacentHTML(
  "afterbegin",
  listPageMarkup(productRange, productType)
);

const productData = materialFilter(productRange, mainData);

const hingesData = categoryFilter(productType, productData);

const targetContainer = document.querySelector(".product-list__wrapper");

generateMarkup(targetContainer, hingesData, listMarkup);
